/**
 * Created by lari on 27/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('examview', {
      restrict: 'E',
      bindings: {
        exam: '='
      },
      templateUrl: 'vcexam/examview-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          var vm = this;
          
        }] // controller
    }); // component

// klammerfriedhof
}());